import { Semantic } from "./colors";
import { media, mediaDown } from "../media-queries";
import { typography } from "../typography";
import { layout } from "./layout";
import { resets } from "../resets";
import { animations } from "../animations";
import { images } from "./images";
import { Colors } from "themes/color-palette";

export const appTheme = {
  ...typography,
  ...layout,
  textColors: Semantic.Text,
  backgroundColors: Semantic.Background,
  borderColors: Semantic.Border,
  graphColors: Semantic.DataVisualization,
  colorPalette: Colors,
  media,
  mediaDown,
  resets,
  animations,
  images,
  isDark: true
};

export { media, mediaDown, resets };
export default appTheme;
